<div
  class="grid"
  style="margin-top: 1rem"
>
  <div class="col-7">
    <p-floatLabel>
      <p-multiSelect
        [(ngModel)]="collectionsSelected"
        [maxSelectedLabels]="3"
        [options]="collectionsOptions"
        [style]="{ width: '100%' }"
        appendTo="body"
        inputId="collectionIds"
        optionLabel="name"
        selectedItemsLabel="{0} sélectionnés"
      />
      <label for="collectionIds">
        <ng-container i18n="@@collection_multi_select_emissions">Emissions</ng-container>
      </label>
    </p-floatLabel>
  </div>
  <div class="col-5">
    <p-floatLabel>
      <p-calendar
        (onClearClick)="clearDate()"
        [(ngModel)]="period"
        [readonlyInput]="true"
        [showButtonBar]="true"
        [style]="{ width: '100%' }"
        appendTo="body"
        dateFormat="dd/mm/yy"
        inputId="period"
        selectionMode="range"
      />
      <label for="period">
        <ng-container i18n="@@collections_multi_select_period">Période</ng-container>
      </label>
    </p-floatLabel>
  </div>
</div>

<div
  class="grid"
  style="margin-top: 2rem"
>
  <div class="col flex justify-content-center align-items-center gap-2">
    <button
      class="p-button-danger"
      (click)="ref.close()"
      label="Annuler"
      i18n-label="@@prompt_editor_cancel_button_label"
      pButton
      type="button"
    ></button>
    <button
      class="p-button-success"
      (click)="onClose()"
      label="Ajouter"
      i18n-label="@@prompt_node_editor_add_button_label"
      pButton
      type="button"
    ></button>
  </div>
</div>
